// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__ufJa0","options":"AnswerScale_options__1b4aS","selected":"AnswerScale_selected__3eEkX"};